// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "deps/" + {"643":"pdfmake","4297":"xlsx","4384":"markerjs2"}[chunkId] + ".js";
};